import React from 'react';
import { CustomTableHeadersProps } from '@dev/ee-components';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { useMobile } from '@api/services/hooks/useMobile';
import { LogTypesString } from '@api/store/logs/types';

import { EventFilter } from '../assets/EventFilter';
import { isLogsScreen } from '../helperFunctions';
import { UseLogsTableDataHeadersInterface } from '../Interface';
import { useEventsFilterOptions } from './useEventsFilterOptions';

export const useLogTableHeaders = ({
    selectedEventsCheckboxes,
    onHeadersEventFilterClick,
    eventFiltersType,
}: UseLogsTableDataHeadersInterface): (CustomTableHeadersProps | string)[] => {
    const { logType = LogTypesString.EMAIL } = useParams<{ logType: LogTypesString }>();
    const { t } = useTranslation();
    const isMobile = useMobile();
    const eventsOptions = useEventsFilterOptions(eventFiltersType);

    const isSmsLogScreen = isLogsScreen(LogTypesString.SMS, logType);

    if (isMobile) {
        const screenHeaders = {
            [LogTypesString.NOTIFICATION]: [t('to'), t('subject'), t('event'), t('bouncetype')],
            [LogTypesString.EMAIL]: [t('to'), t('subject'), t('event'), t('bouncetype')],
            [LogTypesString.SMS]: [t('number'), t('event'), t('bouncetype')],
        };
        return screenHeaders?.[logType];
    }

    if (isSmsLogScreen) {
        return [
            { id: 'to' as string, columnAlign: 'left', label: t('number') },
            {
                id: 'createDate' as string,

                columnAlign: 'right',
                headerAlign: 'right',
                label: t('date'),
            },

            {
                id: 'event' as string,

                columnAlign: 'left',
                label: t('event'),
                filterIcon: (
                    <EventFilter
                        selectedCheckboxes={selectedEventsCheckboxes}
                        onHeadersEventFilterClick={onHeadersEventFilterClick}
                        options={eventsOptions}
                    />
                ),
            },
            { id: 'icon' as string, columnAlign: 'left', label: '' },
        ];
    }
    return [
        { id: 'to' as string, columnAlign: 'left', label: t('to') },
        {
            id: 'createDate' as string,
            columnAlign: 'right',
            headerAlign: 'right',
            label: t('date'),
        },
        {
            id: 'event' as string,
            columnAlign: 'left',
            label: t('event'),
            filterIcon: (
                <EventFilter
                    eventFiltersType={eventFiltersType}
                    selectedCheckboxes={selectedEventsCheckboxes || []}
                    onHeadersEventFilterClick={onHeadersEventFilterClick}
                    options={eventsOptions}
                />
            ),
        },
        {
            id: 'bouncetype' as string,
            columnAlign: 'left',
            label: t('bouncetype'),
        },
        { id: 'icon' as string, columnAlign: 'left', label: '' },
    ];
};
